import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import limitationData from './limitationData.json';
let CoreUtilityService = class CoreUtilityService {
    constructor(coreUtilityApi, companyApi) {
        this.coreUtilityApi = coreUtilityApi;
        this.companyApi = companyApi;
        // #endregion
        // #endregion
        this.postPostman = this.coreUtilityApi.postPostman;
    }
    // #region account infomation
    getCompanyInfomation(data) {
        return this.coreUtilityApi.getCompanyInfomation(data);
    }
    getUserInfomation(data) {
        return this.coreUtilityApi.getUserInfomation(data);
    }
    // #endregion
    // #region cache
    getDefaultList() {
        return this.coreUtilityApi.getDefaultList();
    }
    getCacheData(data) {
        return this.coreUtilityApi.getCacheData(data);
    }
    deleteCache(data) {
        return this.coreUtilityApi.deleteCache(data);
    }
    // #endregion
    // #region  limitation
    getLimitList() {
        return limitationData.data;
    }
    // #endregion
    // #region gateway
    getLoadScript(host) {
        return this.coreUtilityApi.getLoadScript(host);
    }
    getFlush(params) {
        return this.coreUtilityApi.getFlush(params);
    }
    // #endregion
    // #region alertTest
    getAlertTest(params) {
        return this.coreUtilityApi.getAlertTest(params);
    }
    // #region alertDebugger
    analysisAlert(params) {
        return this.coreUtilityApi.analysisAlert(params);
    }
    getAlertInfo(params) {
        return this.coreUtilityApi.getAlertInfo(params);
    }
    sendTargetConcurrencyEmail(params) {
        return this.coreUtilityApi.sendTargetConcurrencyEmail(params);
    }
    postBatchTrial(params) {
        return this.coreUtilityApi.postBatchTrial(params);
    }
    postAccountJobRoleComplement(params) {
        return this.coreUtilityApi.postAccountJobRoleComplement(params);
    }
};
CoreUtilityService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CoreUtilityApi)),
    __param(1, inject(Symbols.CompanyApi)),
    __metadata("design:paramtypes", [Object, Object])
], CoreUtilityService);
export { CoreUtilityService };
